import { h } from 'preact';
import { useEffect } from 'preact/hooks';
import { useAdParameters } from '../../common/creative/hooks/useAdParameters';
import { useClickthru } from '../../common/creative/hooks/useClickthru';
import { useControls } from '../../common/creative/hooks/useControls';
import { useManualDuration } from '../../common/creative/hooks/useManualDuration';
import { useMaxSlotSize } from '../../common/creative/hooks/useMaxSlotSize';
import { useSetAdBackgroundColor } from '../../common/creative/hooks/useSetAdBackgroundColor';
import { useSetAdIsDisplay } from '../../common/creative/hooks/useSetAdIsDisplay';
import { useVPAIDPlayState } from '../../common/creative/hooks/useVPAIDPlayState';
import { sendVideoMetadata, teadsApi } from '../../common/teads-api';
import { MPUSize } from '../size';
import { MPUConfig } from './config';
import { MPUCreative } from './creative';

export function MPU() {
  const { updateTime, setAdLoaded } = useControls();
  const { config } = useAdParameters<MPUConfig>();
  useSetAdBackgroundColor('#fff');
  useSetAdIsDisplay(true);
  useEffect(() => {
    teadsApi.hideVideoContainer();
  }, []);

  const { playState } = useVPAIDPlayState();
  useManualDuration(playState.isPlaying, 15, updateTime);

  const onClick = useClickthru(config.destination_url);

  const { width: maxSlotWidth } = useMaxSlotSize();

  useEffect(() => {
    sendVideoMetadata({
      width: maxSlotWidth,
      height: MPUSize.height,
    });
    setAdLoaded();
  }, [maxSlotWidth]);

  return <MPUCreative size={MPUSize} onClick={onClick} style={{ cursor: 'pointer' }} />;
}
